import React, { useState, useEffect } from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';
import LoginPage from './LoginPage';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import { useDispatch } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import Register from '../auth/Register';
import { isAuth } from './actions';

export default function Auth() {
  const { path } = useRouteMatch();
  // const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    document.title = `Dashboard - Ubaform Admin`;
    if (!isAuth()) {
      history.push('/auth');
    } else if (isAuth().role !== 1) {
      history.push('/auth');
    } else {
      history.push('/')
    }
  }, []);

  return (
    <>
      {!isAuth() && (
        <Router>
          <Switch>
            <Route exact path={path} component={LoginPage} />
            <Route path={`${path}/register`} component={Register} />
            <Route path={`${path}/forgot-password`}>
              <ForgotPassword />
            </Route>
            <Route
              path={`${path}/reset-password/:_id`}
              component={ResetPassword}
            />
            {/* <Route  path={`${path}/public/:id/:cusName/:bookTime/:bookDate`} component={Public}/> */}
            <Route path='*' component={LoginPage} />
          </Switch>
        </Router>
      )}
    </>
  );
}
